jsonpFunctionUIB([5],{

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        var trackGTMEvents = function(options, callback){
	            
	            var dataLayerName = options.dataLayerName || 'dataLayer';
	            var eventPrefix = options.datapointPrefix || '';
	            if (eventPrefix!='') eventPrefix = eventPrefix+".";
	            var ignoreEventsArr = options.ignoreEvents || [];
	            var trackEventsArr = options.trackEvents || [];
	            var ignoreEventsLength = ignoreEventsArr.length;
	            var trackEventsLength = trackEventsArr.length;
	            var defaultTracking = trackEventsLength === 0;
	            
	            var matchRuleShort = function (str, rule) {
	                return new RegExp("^" + rule.replace(/[.?+^$[\]\\(){}|-]/g, "\\$&").split("*").join(".*") + "$").test(str);
	            }
	            var trackTransaction = function(id,revenue,tax,shipping,affiliation,currency,coupon){
	                if (id) uDash.saveAttribute('transactionId',id);
	                if (revenue && !isNaN(revenue*1)) uDash.saveAttribute('revenue',revenue*1);
	                if (currency) uDash.saveAttribute('transactionCurrency',currency);
	                if (coupon) uDash.saveAttribute('transactionCoupon',coupon);
	                if (shipping && !isNaN(shipping*1)) uDash.saveAttribute('transactionShipping',shipping*1);
	                if (tax && !isNaN(tax*1)) uDash.saveAttribute('transactionTax',tax*1);
	                if (affiliation) uDash.saveAttribute('transactionTax',affiliation);
	            }
	            var trackTransactionItems = function(id,name,quantity,mainCategory,subCategory){
	                var n = [];
	                if (mainCategory) n.push(mainCategory);
	                if (subCategory) n.push(subCategory);
	                if (name) n.push(name);
	                for (var i = 0; i<quantity*1; i++){
	                    uDash.saveMeta('purchasedItemName',n.join('/'));
	                    uDash.saveMeta('purchasedItemId',id);
	                }
	            }
	            var trackEcommerce = function (d){
	                var o, item, j;
	                if (d[1] && d[1]==="purchase"){
	                    //GA4
	                    o = d[2];
	                    if (o){
	                        trackTransaction(o.transaction_id,o.value,o.tax,o.shipping,o.affiliation,o.currency,o.coupon);
	                        if (o.items){
	                            for (j = 0;j<o.items.length;j++){
	                                item = o.items[j];
	                                trackTransactionItems(item.item_id, item.item_name, item.quantity, item.item_category, item.item_category2);
	                            }
	                        }
	                    }
	                }else if (d.ecommerce && d.ecommerce.purchase){
	                    //UA enhanced commerce
	                    o = d.ecommerce.purchase.actionField;
	                    if (o){
	                        trackTransaction(o.id,o.revenue,o.tax,o.shipping,o.affiliation,o.currency,o.coupon);
	                    }
	                    if (d.ecommerce.purchase.products){
	                        for (j = 0;j<d.ecommerce.purchase.products.length;j++){
	                            item = d.ecommerce.purchase.products[j];
	                            trackTransactionItems(item.id, item.name, item.quantity, item.category);
	                        }
	                    }
	                }else if (d.transactionId){
	                    //UA standard commerce
	                    o = d;
	                    trackTransaction(o.transactionId,o.transactionTotal,d.transactionTax,d.transactionShipping,d.transactionAffiliation);
	
	                    if (o.transactionProducts){
	                        for (j = 0;j<o.transactionProducts.length;j++){
	                            item = o.transactionProducts[j];
	                            trackTransactionItems(item.sku, item.name, item.quantity, item.category);
	                        }
	                    }
	                }
	            }
	            var trackEvents = function (i){
	                while (i<dl.length) {
	                    if (options.trackEcommerce) trackEcommerce(dl[i])
	                    var track = defaultTracking;
	                    var matched = false;
	                    var event;
	                    var eventO;
	                    if (dl[i][1] && typeof dl[i][1]==="string"){
	                        event = dl[i][1];
	                        eventO = dl[i][2];
	                    } else if (dl[i].event){
	                        event = dl[i].event;
	                        eventO = dl[i];
	                    }
	                    if (event){
	                        for (var j=0; j<ignoreEventsLength; j++){
	                            if (matchRuleShort(event,ignoreEventsArr[j])){
	                                track = false;
	                                break;
	                            }
	                        }
	                        if (!matched){
	                            for (var j=0; j<trackEventsLength; j++){
	                                if (matchRuleShort(event,trackEventsArr[j])){
	                                    track = true;
	                                    break;
	                                }
	                            }
	                        }
	                        if (track){
	                            var o = {};
	                            for (var key in eventO){
	                                if (key.indexOf('gtm.')!==0 && key !== 'event'){
	                                    if (typeof eventO[key] !== 'object'){
	                                        o[key] = eventO[key];
	                                    }
	                                }
	                            }
	                            uDash.saveMeta(eventPrefix+dl[i].event,JSON.stringify(o));
	                        }
	                    }
	                    i++;
	                }
	                setTimeout(trackEvents, 100, i);
	            }
	
	            var dl = window[dataLayerName];
	            if (dl && typeof dl !=='undefined'){                
	                trackEvents(0);      
	                callback(null);
	            }else{
	                callback(new Error("No GTM window."+dataLayerName+" found. Consider adding it to the response dependencies."));
	            }
	        }
	        return trackGTMEvents;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })

});


// WEBPACK FOOTER //
// responses/data-collection/trackGTMEvents/trackGTMEvents.js